"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToBoolean = convertToBoolean;
exports.convertToBooleanDefaultToTrue = convertToBooleanDefaultToTrue;
exports.convertToBooleanDefaultToFalse = convertToBooleanDefaultToFalse;
function convertToBoolean(opts) {
    return opts?.value?.toLowerCase() === "true";
}
function convertToBooleanDefaultToTrue(opts) {
    return !opts?.value || convertToBoolean(opts);
}
function convertToBooleanDefaultToFalse(params) {
    return !params ? false : convertToBoolean(params);
}
//# sourceMappingURL=transformStringToBoolean.js.map